<template>
  <div class="layer-modal"
    @click.self="closeLayer">
    <div class="toast group_layer">
      <p>This is the page requires login settings.<br>Enter the appropriate ID and PW in the existing login page.</p>
      <p class="ellipsis url-area">Login Page URL : {{ reportData.loginUrl }}</p>
      <div class="input--wrap">
        <p class="login">
          <label for="userId">ID</label><input type="text" name="userId" id="userId" maxlength="60"
            v-model.trim="model.id" />
          <strong class="wrong" v-if="errors.id">* {{ $t('diagnostics.emptyId') }}</strong>
        </p>
        <p class="login">
          <label for="userPW">PW</label><input type="password" name="userPW" id="userPW" maxlength="60"
            v-model="model.password" />
          <strong class="wrong" v-if="errors.password">* {{ $t('diagnostics.emptyPassword') }}</strong>
        </p>
      </div>
      <button type="button" class="btn_2"
        @click="onConfirmClick">{{ $t('common.confirm') }}</button>
      <button @click.self="closeLayer" class="close_layer"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RequireLoginLayer',
  props: ['reportData'],
  data () {
    return {
      errors: {},
      model: {
        id: '',
        password: ''
      }
    }
  },
  created () {
    this.model.id = this.reportData.loginId
  },
  methods: {
    onConfirmClick () {
      this.errors = {}
      const id = this.model.id.trim()
      const password = this.model.password

      if (id === '') {
        this.errors.id = true
      }

      if (password === '') {
        this.errors.password = true
      }

      if (Object.keys(this.errors).length) {
        return
      }

      this.$emit('onConfirmClick', id, password)
    },
    closeLayer () {
      this.$emit('onCloseClick')
    }
  }
}
</script>

<style>
.toast {
  position: fixed;
  top: 200px;
  min-width: 300px;
  padding: 40px;
  text-align: center;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}

.toast p {
  padding-top: 20px;
}

.toast p:first-child {
  padding: 0;
}

.toast .input--wrap {
  width: 80%;
  margin: 0 auto;
  text-align: left;
}

.toast .input--wrap input {
  width: 100%;
  margin-top: 10px;
}

.toast .input--wrap strong {
  display: inline-block;
  margin: 10px 0;
}

.toast.group_layer button:not(.close_layer) {
  height: 34px;
  line-height: 34px;
  margin-top: 20px;
}

.toast .wrong {
  font-size: 11px;
  color: #ff0000;
}

button.close_layer {
  background-image: url("../../../assets/images/ico_close.png");
  background-size: contain;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-position: center center;
  position: absolute;
  top: 15px;
  right: 15px;
}

/* 20180703: 다시 진단 로그인 */
.toast .url-area {
  background-color: #F2F2F2;
  color: #000;
  font-size: 12px;
  padding: 12px 10px;
  width: 450px;
  text-align: left;
  margin-top: 10px;
}

.toast .input--wrap .login {
  overflow: hidden;
  position: relative;
  padding-top: 0;
  padding-bottom: 20px;
}

.toast .input--wrap .login:first-child {
  margin-top: 20px;
}

.toast .input--wrap .login label {
  float: left;
  line-height: 30px;
}

.toast .input--wrap .login input {
  float: right;
  width: 80%;
  margin: 0;
}

.toast .input--wrap .login .wrong {
  position: absolute;
  left: 80px;
  top: 25px;
}

.toast .url-area {
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/valid-member/dashboard/RequireLoginLayer.vue